import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';

/**
  * This is base view for filter
  * It intilizate controls from template
  * For customized value control/view:
  *    1. Extend this view, override prepareView.
  *    2. Update predicateCreator.js
  *    3. Update filterSchema.js for the operatorMapping
  */
export class Predicate extends Backbone.View {
  initialize(options) {
    this.ko_model = options.ko_model;
  }

  render() {
    this.prepareView();
    ko.applyBindings(this.ko_model, this.el);
    return this;
  }

  prepareView() {
    if (!_.isUndefined(this.ko_model.template())) {
      this.$el.html(this.ko_model.template()(this.ko_model));
    } else {
      throw new TypeError('sub class should implement this function for un-normal ones');
    }
  }
}
